@if (dietMeal) {
  <app-resource-banner [bannerJson]="bannerData"
    (patientResult)="patientResult($event);">
  </app-resource-banner>
}

<div [ngClass]="{'main-content-container':!dialogData}">
  <div [ngClass]="{'main-container-body':!dialogData}">
    @if (!utilService.isMobile() && dietMeal) {
      <div class="page-title-container d-flex">
        <div class="page-title flex-grow-1 ng-star-inserted">
          <div class="mb-0 ng-star-inserted">
            <div class="d-flex align-items-center">
              <div class="pl-2 pr-2 ng-star-inserted"><a class="d-inline-flex" (click)="previous()"
                href="javascript:void(0)"><img src="assets/images/grid-back.png"></a></div>
                <div class="text-capitalize">Update Diet Item </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (showDoubleOrder) {
        <label class="check-wrapper double-order-all">
          {{'field.label.double_order_all' | translate | async}}
          <input type="checkbox" class="checkbox" [(ngModel)]="allDoubleOrder" (change)="toggleAllDoubleOrder()">
          <span class="check-mark"></span>
        </label>
      }

      @for (p of meal_timing ; track p; let i = $index) {
        <div class="row">
          <div class="col-12">
            <div id="accorion-{{i+1}}">
              <div class="accordion pt-1 pb-1">
                <div class="accordion-header" data-toggle="collapse">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="accordion-title text-capitalize pl-3">
                      <span class="accordion-title text-capitalize float-left">
                        <!-- {{getData(d.key) | translate | async}} -->
                        {{p.name}}
                      </span>
                    </div>
                    <!-- <div class="accordion-icon" (click)="showHideAccordian(i)">
                    <i class="fa fa-angle-down" aria-hidden="true"
                    style="transform: rotate(90deg);"></i>
                  </div> -->
                </div>
              </div>
              @if (openAccordian[i]) {
                <div class="accordion-body show" id="accordion-{{i+1}}"><!-- -->
                  <div class="col-12 p-0 table-last-elements">
                    @if (showDoubleOrder) {
                      <label class="check-wrapper double-order-check">
                        {{'field.label.double_order' | translate | async}}
                        <input type="checkbox" class="checkbox" [ngModel]="isDoubleOrder(p.id)"
                          (ngModelChange)="setDoubleOrder(p.id, $event)">
                        <span class="check-mark"></span>
                      </label>
                    }
                    @if (resourceDef) {
                      <dhs-editable-grid [json]="resourceDef"
                        #formobj [config]="getConfig(p.id)"
                        (listen_changes)="listen_changes($event,p.id)" class="diet-meal-item-c">
                      </dhs-editable-grid>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <div class="row float-left w-100">
      <div class="col-12 text-center mt-4 card-footer-actions" id="scroll_window">
        <button type="button" class="primary-btn bookBtn" (click)="submitMealItem()">
          {{'field.label.update' | translate | async}}
          <i class="fa fa-check ml-2" aria-hidden="true"></i>
        </button>

      </div>
    </div>
  </div>
</div>